/** @type {import("@intellectability/platform-common/router").RouteDefinition[]} */
const systemRoutes = [
    {
        path: "/test-mode",
        component: () => import("./TestMode/TestModePanel.svelte"),
        title: "Test Mode",
        layout: "popover"
    }

];

export default systemRoutes;